import type { RenderItemProps } from '@/components/StructuredVirtualList'

import { AlertItem } from './AlertItem'

type Props = RenderItemProps<'eventAlerts'>

export function Item(props: Props) {
  return props.type === 'item' ? <AlertItem {...props} /> : null
}
